import { Validator } from '@vista-digital/validator';
import { reactComponentValidator } from '../../../../validators/react-component';
import { TicketPickerSkeleton } from '../subcomponents/skeleton';
import { TicketPickerTableHeader } from '../subcomponents/table-header';
import { TicketPickerTableRow } from '../subcomponents/table-row';
export const defaultTicketPickerSubcomponents = {
    Header: TicketPickerTableHeader,
    Row: TicketPickerTableRow,
    Skeleton: TicketPickerSkeleton
};
export const ticketPickerSubcomponentsValidator = Validator.object({
    Header: reactComponentValidator,
    Row: reactComponentValidator,
    Skeleton: reactComponentValidator
});
